const e=e=>{const t={length:e.length>7,uppercase:/[A-Z]/.test(e),lowercase:/[a-z]/.test(e),number:/\d/.test(e),all:!0};return t.all=Object.values(t).every((e=>e)),t};export{e as isPasswordValidationsValid};
